import React from 'react';
import { Link } from 'react-router-dom';
import CookieConsent from "react-cookie-consent";

function CookieConsenBar() {
    return (
        <CookieConsent
            location="bottom"
            buttonText="Accept All"
            cookieName="userConsent"
            style={{
                background: "#2b2b2b",
                padding: "20px",
                marginTop: "0",
                transition: "margin-top 0.3s ease"
            }}
            buttonStyle={{ backgroundColor: "#d2fc61", color: "black", fontSize: "15px", padding: "10px 20px", borderRadius: "5px", border: "none", cursor: "pointer" }}
            expires={365}
        >
            To ensure you have the best possible experience, we use cookies on our sites. Some are necessary for helping our sites run smoothly and securely, others are optional and help us create customized experiences. You can reviewing our{" "}
            <Link to="/privacy-policy" style={{ color: "#d2fc61", textDecoration: "underline" }}>
                Privacy Policy.
            </Link>
            <style>
                {`
                    @media only screen and (max-width: 600px) {
                        .react-cookie-consent {
                            margin-top: 50px !important;
                        }
                    }
                `}
            </style>
        </CookieConsent>
    );
}

export default CookieConsenBar;
